// extracted by mini-css-extract-plugin
export default {"LogoPreview":"styles_LogoPreview__oY7Iz","container":"styles_container__oq2Ta","active":"styles_active__IzIkP"};